import {
  ProductCatalogSource,
  ProductLookupResult,
  ProductSearchRequest,
} from '../Services/products.service';

export const PRODUCTS_PAGE_SIZE = 15;

export interface ProductsFilterValue {
  drugName: string;
  manufacturer: string;
  catalogUk: boolean;
  catalogIrish: boolean;
}

export interface ProductsResultsState {
  loading: boolean;
  hasSearched: boolean;
  products: ProductLookupResult[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
  errorMessage?: string;
}

export type ProductsFetchAction =
  | { type: 'search' }
  | { type: 'page'; pageNumber: number };

interface FetchContext {
  action: ProductsFetchAction | null;
  state: ProductsResultsState;
}

export function createInitialResultsState(): ProductsResultsState {
  return {
    loading: false,
    hasSearched: false,
    products: [],
    pageNumber: 1,
    pageSize: PRODUCTS_PAGE_SIZE,
    totalPages: 0,
    totalRecords: 0,
  };
}

export function reduceResultsState(
  state: ProductsResultsState,
  action: ProductsFetchAction,
): ProductsResultsState {
  switch (action.type) {
    case 'search':
      return {
        ...state,
        pageNumber: 1,
        hasSearched: true,
        errorMessage: undefined,
      };
    case 'page':
      return {
        ...state,
        pageNumber: action.pageNumber,
        errorMessage: undefined,
      };
  }
}

export function isFetchAction(
  action: ProductsFetchAction | null,
): action is ProductsFetchAction {
  return action?.type === 'search' || action?.type === 'page';
}

export function buildSearchRequest(
  filters: ProductsFilterValue,
  pageNumber: number,
  pageSize: number,
): ProductSearchRequest {
  const catalogSources: ProductCatalogSource[] = [];
  if (filters.catalogUk) {
    catalogSources.push(ProductCatalogSource.CdData);
  }
  if (filters.catalogIrish) {
    catalogSources.push(ProductCatalogSource.Irish);
  }

  const request: ProductSearchRequest = {
    pageNumber,
    pageSize,
    catalogSources,
  };

  const drugName = filters.drugName.trim();
  if (drugName) {
    request.drugNames = [drugName];
  }

  const manufacturer = filters.manufacturer.trim();
  if (manufacturer) {
    request.manufacturers = [manufacturer];
  }

  return request;
}

export function applyFetchContext(
  acc: FetchContext,
  action: ProductsFetchAction,
): FetchContext {
  return {
    action,
    state: reduceResultsState(acc.state, action),
  };
}
